module.exports = __webpack_public_path__ + "static/media/1 13 vært.c4b115a9.mp3";